export const pxToRem = (pixels: number): string => {
  const base16 = 16
  return `${pixels / base16}rem`
}
